export default {
  backgroundColor: 'white',
  primaryColor: '#3c4252'
}



// WEBPACK FOOTER //
// ./src/styles/theme.js